import React, { ReactNode, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useDialog } from './DialogContext';

interface DialogOverlayProps {
  children: ReactNode;
}

const DialogOverlay = ({ children }: DialogOverlayProps) => {
  const classes = useStyles();
  const { isOpen, onClose } = useDialog();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }

    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={classes.overlay} onClick={onClose}>
      {children}
    </div>
  );
};

const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
});

export default DialogOverlay;
